import React, {useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import TextField from './components/TextField';
import {FaMobileAlt} from 'react-icons/fa';
import Post from './components/Post';
import color from './components/color';
import betx from './images/betx.png';
import splash3 from './images/splash3.jpg';

const PostFree = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = location.state || {};
  const [id] = useState(params.id || '');
  const [otp, setOtp] = useState('');
  const [type] = useState(params.type || '');
  const [loading, setLoading] = useState(false);

  const login = () => {
    setLoading(true);
    Post.Otp({id, otp, type}).then(res => {
      setLoading(false);
      if (!res.error) {
        if (type === 'forgot') {
          localStorage.setItem('user_bkp', JSON.stringify(res.data));
          navigate('/password');
        } else {
          alert(res.success);
          navigate('/login');
        }
      } else {
        alert(res.errorMsg);
      }
    });
  };

  return (
    <>
      <style>{`
        .custominput::placeholder {
          color: white;
        }
      `}</style>
      <div style={styles.bg}>
        {loading && (
          <div style={styles.spinnerOverlay}>
            <div className="spinner" style={styles.spinner} />
            <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
          </div>
        )}

        <div style={styles.layer}>
          <div style={styles.imageContainer}>
            <img src={betx} alt="logo" style={styles.logo} />
          </div>
          <h2 style={styles.heading}>OTP to Verify Mobile</h2>
          <div style={styles.card}>
            {/* <TextField
            label="Enter OTP"
            tintColor={color.secondry}
            icon={<FaMobileAlt color="#ffffff" size={25} />}
            value={otp}
            type="number"
            onChange={e => setOtp(e.target.value)}
          /> */}
            <div style={styles.inputWrapper}>
              <input
                type="number"
                maxLength={10}
                placeholder="Enter OTP"
                className="custominput"
                value={otp}
                onChange={e => setOtp(e.target.value)}
                style={{
                  flex: 1,
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: 'white',
                  outline: 'none',
                }}
              />
            </div>
            <button style={styles.loginBtn} onClick={login}>
              <span style={styles.loginBtnText}>Next</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostFree;

const styles = {
  bg: {
    height: '100vh',
    width: '100%',
    backgroundImage: `url(${splash3})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spinnerOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(0,0,0,0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  spinner: {
    width: 50,
    height: 50,
    border: '6px solid #ccc',
    borderTop: '6px solid #0AB4A7',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  layer: {
    textAlign: 'center',
    color: 'white',
  },
  imageContainer: {
    marginTop: 60,
  },
  logo: {
    width: 250,
    height: 200,
  },
  heading: {
    color: 'white',
    fontWeight: 'bold',
    marginTop: 10,
  },
  card: {
    width: '300px',
    margin: '20px auto',
    borderRadius: '20px',
    padding: '20px',
    backgroundColor: 'rgba(0,0,0,0.4)',
    border: '1px solid #10C2AA',
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    border: '2px solid #10C2AA',
    borderRadius: 10,
    backgroundColor: 'rgba(255,255,255,0.1)',
    padding: '10px 12px',
    marginBottom: 10,
  },
  loginBtn: {
    width: '100%',
    borderRadius: '10px',
    padding: '15px',
    backgroundColor: '#0AB4A7',
    cursor: 'pointer',
    border: 'none',
    marginTop: '20px',
  },
  loginBtnText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 16,
  },
};
